/**
 * Copyright (c) 2021 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React, { useState } from 'react';
import { connect } from 'react-redux';

import * as consts from '../../const.js';
import { Button } from 'tc-client-common';
import { hideModal, showModal } from '../../actions/actions';
import { MODAL_TYPE_CHANGE_ANSWERS_OPTIN_OPTOUT } from '../../constants/modalTypes';
import { ControlLabel, Form, FormControl, FormGroup, Grid, Row } from 'react-bootstrap';
import { CHANGE_ANSWERS_DATE_REASON_DESCRIPTION, CHANGE_ANSWERS_OPTIN_OPTOUT, VERSION } from '../../const';
import DatePicker from 'react-datepicker';

import { clearConsentDocuments4SoPChangeAnswers } from '../../actions/changeAnswers4sop.actions';

const ChangeAnswersDateReasonComponent = (props) => {
  const { signatureDate: providedSignatureDate, reason: providedReason, minSignatureDate } = props.props;

  const [signatureDate, setSignatureDate] = useState(providedSignatureDate);
  const [reason, setReason] = useState(providedReason);

  const submit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    props.next({ ...props.props, reason, signatureDate });
  };

  const isButtonNextDisabled = !signatureDate || !reason;
  return (
    <div>
      <Form noValidate horizontal id="change-answers-date-reason-form" onSubmit={(e) => submit(e)}>
        <Grid id="change-answers-grid" fluid>
          <Row key={1}>
            <FormGroup>
              <FormControl.Static>{CHANGE_ANSWERS_DATE_REASON_DESCRIPTION}</FormControl.Static>
            </FormGroup>
          </Row>
          <Row key={2}>
            <FormGroup controlId="signatureDate">
              <ControlLabel>{consts.CHANGE_ANSWERS_DATE}</ControlLabel>
              <br />
              <DatePicker
                onChange={(selectedDate) => setSignatureDate(selectedDate)}
                selected={signatureDate}
                minDate={minSignatureDate && new Date(minSignatureDate)}
                placeholderText="Please select a date"
                isClearable={false}
                className="form-control"
                dropdownMode="select"
                id="signatureDate"
              />
            </FormGroup>
          </Row>
          <Row key={3}>
            <FormGroup controlId="reason">
              <ControlLabel>{consts.CHANGE_ANSWERS_REASON}</ControlLabel>
              <FormControl
                componentClass="textarea"
                placeholder="Please state a reason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                required
              />
            </FormGroup>
          </Row>
        </Grid>
        <div className="edit-modal-footer">
          <hr className="edit-modal-divider" />
          <Button
            type="reset"
            theme="default large-button"
            handleClick={() => props.cancel()}
            label={consts.CANCEL_BTN}
          />
          <Button theme="active large-button" label={consts.NEXT_BTN} type="submit" disabled={isButtonNextDisabled} />
        </div>
      </Form>
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return {
    cancel: () => {
      dispatch(clearConsentDocuments4SoPChangeAnswers());
      dispatch(hideModal());
    },
    next: (props) => {
      const { consentName, consentVersion } = props;

      dispatch(
        showModal(MODAL_TYPE_CHANGE_ANSWERS_OPTIN_OPTOUT, {
          shouldCloseOnOverlayClick: false,
          title: CHANGE_ANSWERS_OPTIN_OPTOUT,
          details: [consentName, '-', VERSION, consentVersion].join(' '),
          className: 'document-status-optinoptout-modal',
          props: props
        })
      );
    }
  };
};

const ChangeAnswersDateReasonContainer = connect(mapStateToProps, mapDispatchToProps)(ChangeAnswersDateReasonComponent);

const ChangeAnswersDateReasonModal = (props) => {
  return (
    <div>
      <ChangeAnswersDateReasonContainer {...props} />
    </div>
  );
};

export { ChangeAnswersDateReasonContainer, mapStateToProps, mapDispatchToProps, ChangeAnswersDateReasonComponent };
export default ChangeAnswersDateReasonModal;
